import { Link } from "react-router-dom";
import type { Anime } from "@/mocks/types";

interface AnimeCardProps {
  anime: Anime;
  index?: number;
}

export default function AnimeCard({ anime, index = 0 }: AnimeCardProps) {
  return (
    <Link
      to={`/anime/detail/${anime.id}`}
      className="group block cursor-pointer animate-fade-up"
      style={{ animationDelay: `${Math.min(index, 8) * 55}ms` }}
    >
      <div className="relative w-full aspect-[3/4] rounded-lg overflow-hidden bg-background-200">
        <img
          src={anime.cover}
          alt={`${anime.title}封面`}
          title={`${anime.title} 动漫作品介绍`}
          className="w-full h-full object-cover transition-transform duration-500 ease-smooth group-hover:scale-[1.06]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/10 to-transparent opacity-90" />
        <span className="absolute top-2.5 left-2.5 px-2 py-0.5 rounded-md bg-foreground-950/70 backdrop-blur-sm text-[11px] text-background-50 font-label">
          {anime.year}
        </span>
        <span className="absolute top-2.5 right-2.5 px-2 py-0.5 rounded-md bg-primary-500 text-[11px] text-background-50 font-label flex items-center gap-1">
          <i className="ri-star-fill text-[10px]" />
          {anime.rating.toFixed(1)}
        </span>
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="font-heading font-semibold text-background-50 text-sm md:text-base leading-snug line-clamp-2">
            {anime.title}
          </h3>
          <div className="mt-1.5 flex flex-wrap gap-1">
            {anime.genres.slice(0, 2).map((g) => (
              <span key={g} className="text-[11px] text-background-200">
                {g}
              </span>
            ))}
            <span className="text-[11px] text-background-300">· {anime.region}</span>
          </div>
        </div>
      </div>
      <div className="mt-2.5 px-0.5">
        <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed">{anime.summary}</p>
      </div>
    </Link>
  );
}